import request from '@/utils/request'
let baseUrl="/api/competition/note/"
export function add(data) {
    return request({
      url: baseUrl+'add',
      method: 'post',
      data: data
    })
}
export function listDate() {
    return request({
      url: baseUrl+'listDate',
      method: 'get'
    })
}
export function getByDate(date){
  return request({
    url: baseUrl+"getByDate?date="+date
  })
}


// WEBPACK FOOTER //
// ./src/api/note.js